// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.lsn-question-block-ratings .lsn-rubrics-wrapper .lsn-form-control-error-message,
.lsn-question-block-rubrics .lsn-rubrics-wrapper .lsn-form-control-error-message {
  position: absolute;
  left: 3.5rem;
  text-align: left;
  top: -0.05rem;
  line-height: normal;
  pointer-events: none;
}
.lsn-question-block-ratings .lsn-rubrics-wrapper input[type='text'],
.lsn-question-block-rubrics .lsn-rubrics-wrapper input[type='text'] {
  height: 0.1px;
  border: 0 !important;
  box-shadow: none !important;
  position: absolute;
}
.lsn-question-block-ratings .lsn-rubrics-rating-marks-array,
.lsn-question-block-rubrics .lsn-rubrics-rating-marks-array {
  position: absolute;
  left: 5%;
  right: 5%;
  bottom: 0;
}
.lsn-question-block-ratings .lsn-rubrics-rating-mark,
.lsn-question-block-rubrics .lsn-rubrics-rating-mark {
  background: white;
  display: block;
  font-size: 0px;
  box-shadow: color-mix(in srgb, var(--main-primary-color) 40%, transparent) 1px 1px 1px 0px;
  width: 10px;
  height: 10px;
  background-color: var(--js-component-color);
  transform: translate(-50%, 40%) rotate(45deg) !important;
  position: absolute;
  bottom: -0.3rem;
  color: var(--main-dark-gray);
  left: var(--js-left-perc);
  z-index: 1;
}
.lsn-question-block-ratings .lsn-rubrics-rating-mark.up,
.lsn-question-block-rubrics .lsn-rubrics-rating-mark.up {
  transform: translate(-50%, -50%) rotate(-135deg) !important;
  bottom: auto;
  top: 0;
  z-index: 0;
}
.lsn-question-block-ratings #likert-header,
.lsn-question-block-rubrics #likert-header {
  position: sticky;
  top: -1px;
  z-index: 9;
  margin-bottom: 1.6rem;
}
.lsn-question-block-ratings .floating-panel,
.lsn-question-block-rubrics .floating-panel {
  background: var(--main-bg-color-lighter);
  position: relative;
  z-index: 3;
  transition: transform 1s, box-shadow 0.5s;
  box-shadow: var(--main-dark-gray) 0px 2px 2px -2px;
  width: 100%;
  justify-content: space-evenly;
  margin-bottom: 1rem;
  padding-bottom: 1.5rem;
}
.lsn-question-block-ratings .floating-panel.sticky,
.lsn-question-block-rubrics .floating-panel.sticky {
  box-shadow: var(--main-dark-gray) 0px 26px 12px -20px;
}
.lsn-question-block-ratings .lsn-rubrics-rating-items,
.lsn-question-block-rubrics .lsn-rubrics-rating-items {
  top: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
  row-gap: 1rem;
  padding: 1rem 0 1rem 2.5rem;
  position: relative;
}
.lsn-question-block-ratings .lsn-rubrics-level-item,
.lsn-question-block-rubrics .lsn-rubrics-level-item {
  position: static;
  z-index: 2;
  display: flex;
  font-weight: bolder;
  line-height: normal;
  flex-grow: 1;
  cursor: default;
  width: 100%;
  max-width: none;
  min-width: unset;
  align-items: baseline;
  flex-direction: row-reverse;
  justify-content: flex-end;
  column-gap: 0.5rem;
  transform: translate(1%, -0.5rem);
}
.lsn-question-block-ratings .lsn-rubrics-level-item .lsn-rubrics-levels-tooltip,
.lsn-question-block-rubrics .lsn-rubrics-level-item .lsn-rubrics-levels-tooltip {
  cursor: pointer;
  color: var(--main-primary-color);
  display: block;
}
.lsn-question-block-ratings .rc-slider,
.lsn-question-block-rubrics .rc-slider {
  width: 90%;
  padding: 0;
  margin: 0 auto !important;
  cursor: pointer;
}
.lsn-question-block-ratings .rc-slider.invalid .rc-slider-rail,
.lsn-question-block-rubrics .rc-slider.invalid .rc-slider-rail {
  border-color: color-mix(in srgb, var(--main-red), var(--main-white)) !important;
}
.lsn-question-block-ratings .rc-slider.invalid .rc-slider-track,
.lsn-question-block-rubrics .rc-slider.invalid .rc-slider-track {
  background-color: color-mix(in srgb, var(--main-red), var(--main-white)) !important;
}
.lsn-question-block-ratings .rc-slider.invalid .rc-slider-handle,
.lsn-question-block-rubrics .rc-slider.invalid .rc-slider-handle {
  background-color: var(--main-red);
}
.lsn-question-block-ratings .rc-slider.invalid .rc-slider-handle:focus,
.lsn-question-block-rubrics .rc-slider.invalid .rc-slider-handle:focus {
  box-shadow: 0 0 0 3px var(--main-red);
}
.lsn-question-block-ratings .rc-slider.invalid .rc-slider-handle:focus:after,
.lsn-question-block-rubrics .rc-slider.invalid .rc-slider-handle:focus:after {
  box-shadow: 2.3px 2.3px 0px 1.7px var(--main-red);
}
.lsn-question-block-ratings .rc-slider.invalid .rc-slider-handle:after,
.lsn-question-block-rubrics .rc-slider.invalid .rc-slider-handle:after {
  background-color: var(--main-red);
}
.lsn-question-block-ratings .rc-slider.invalid .rc-slider-handle.rc-slider-handle-dragging,
.lsn-question-block-rubrics .rc-slider.invalid .rc-slider-handle.rc-slider-handle-dragging {
  box-shadow: 0 0 4px 4px var(--main-red), inset 1px 1px 2px 1px var(--main-black), inset -1px -1px 0px 0px var(--main-white);
}
.lsn-question-block-ratings .rc-slider.invalid .rc-slider-handle.rc-slider-handle-dragging:after,
.lsn-question-block-rubrics .rc-slider.invalid .rc-slider-handle.rc-slider-handle-dragging:after {
  box-shadow: 4px 4px 4px 1px var(--main-red), inset -1px -1px 0px 0px var(--main-white);
}
.lsn-question-block-ratings .rc-slider.invalid .rc-slider-dot,
.lsn-question-block-rubrics .rc-slider.invalid .rc-slider-dot {
  opacity: 0.3;
}
.lsn-question-block-ratings .rc-slider-handle,
.lsn-question-block-rubrics .rc-slider-handle {
  position: absolute;
  margin-left: 0;
  margin-top: -2px;
  width: 14px;
  height: 16px;
  cursor: grab;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  border: none !important;
  background-color: var(--main-primary-color);
  background-repeat: no-repeat;
  opacity: 1;
  z-index: 2;
}
.lsn-question-block-ratings .rc-slider-handle:focus,
.lsn-question-block-rubrics .rc-slider-handle:focus {
  box-shadow: 0 0 0 3px var(--main-primary-color);
}
.lsn-question-block-ratings .rc-slider-handle:focus:after,
.lsn-question-block-rubrics .rc-slider-handle:focus:after {
  box-shadow: 2.3px 2.3px 0px 1.7px var(--main-primary-color);
}
.lsn-question-block-ratings .rc-slider-handle:after,
.lsn-question-block-rubrics .rc-slider-handle:after {
  display: block;
  content: ' ';
  background-color: var(--main-primary-color);
  width: 10px;
  height: 10px;
  position: absolute;
  bottom: -5px;
  left: 2px;
  transform: rotate(45deg);
  z-index: 1;
}
.lsn-question-block-ratings .rc-slider-handle.rc-slider-handle-dragging,
.lsn-question-block-rubrics .rc-slider-handle.rc-slider-handle-dragging {
  box-shadow: 0 0 4px 4px var(--main-primary-color), inset 1px 1px 2px 1px var(--main-black), inset -1px -1px 0px 0px var(--main-white);
}
.lsn-question-block-ratings .rc-slider-handle.rc-slider-handle-dragging:after,
.lsn-question-block-rubrics .rc-slider-handle.rc-slider-handle-dragging:after {
  box-shadow: 4px 4px 4px 1px var(--main-primary-color), inset -1px -1px 0px 0px var(--main-white);
}
.lsn-question-block-ratings .rc-slider-rail,
.lsn-question-block-rubrics .rc-slider-rail {
  height: 15px !important;
  background-color: var(--main-white) !important;
  border: var(--main-border-width) solid var(--main-border-color) !important;
}
.lsn-question-block-ratings .rc-slider-track,
.lsn-question-block-rubrics .rc-slider-track {
  height: 15px !important;
}
.lsn-question-block-ratings .rc-slider-step,
.lsn-question-block-rubrics .rc-slider-step {
  height: 10px !important;
}
.lsn-question-block-ratings .rc-slider-step > span:nth-child(1),
.lsn-question-block-rubrics .rc-slider-step > span:nth-child(1) {
  display: none;
}
.lsn-question-block-ratings .rc-slider-dot,
.lsn-question-block-rubrics .rc-slider-dot {
  bottom: 0px !important;
  width: 5px !important;
  margin-left: 0px !important;
  height: 5px !important;
  background-color: var(--main-border-color) !important;
  border: var(--main-border-width) solid var(--main-border-color) !important;
}
.lsn-question-block-ratings .rc-slider-dot-active,
.lsn-question-block-rubrics .rc-slider-dot-active {
  background-color: var(--main-white) !important;
  border: var(--main-border-width) solid var(--main-white) !important;
}
.lsn-question-block-ratings .lsn-rubrics-label,
.lsn-question-block-rubrics .lsn-rubrics-label {
  padding-bottom: 0.5rem;
  padding-right: 2rem;
}
.lsn-question-block-ratings .lsn-rubrics-scales,
.lsn-question-block-rubrics .lsn-rubrics-scales {
  margin-top: -0.5rem;
  display: flex;
  flex-direction: column;
}
.lsn-question-block-ratings .comment-wrapper,
.lsn-question-block-rubrics .comment-wrapper {
  width: 100% !important;
  border: var(--main-border-width) solid var(--main-border-color);
  border-radius: var(--main-control-border-radius);
  outline: none;
  padding: 0 0 0 0.2rem;
  position: relative;
  border-bottom-right-radius: 0;
  margin: 1.3rem auto 0;
}
.lsn-question-block-ratings .comment-wrapper:focus,
.lsn-question-block-rubrics .comment-wrapper:focus,
.lsn-question-block-ratings .comment-wrapper:active,
.lsn-question-block-rubrics .comment-wrapper:active,
.lsn-question-block-ratings .comment-wrapper:focus-within,
.lsn-question-block-rubrics .comment-wrapper:focus-within {
  border-color: var(--main-primary-color);
}
.lsn-question-block-ratings .comment-wrapper:focus::before,
.lsn-question-block-rubrics .comment-wrapper:focus::before,
.lsn-question-block-ratings .comment-wrapper:active::before,
.lsn-question-block-rubrics .comment-wrapper:active::before,
.lsn-question-block-ratings .comment-wrapper:focus-within::before,
.lsn-question-block-rubrics .comment-wrapper:focus-within::before {
  border-color: var(--main-primary-color);
}
.lsn-question-block-ratings .comment-wrapper:focus i,
.lsn-question-block-rubrics .comment-wrapper:focus i,
.lsn-question-block-ratings .comment-wrapper:active i,
.lsn-question-block-rubrics .comment-wrapper:active i,
.lsn-question-block-ratings .comment-wrapper:focus-within i,
.lsn-question-block-rubrics .comment-wrapper:focus-within i {
  color: var(--main-primary-color);
}
.lsn-question-block-ratings .comment-wrapper .lsn-rubrics-rating-marks-array,
.lsn-question-block-rubrics .comment-wrapper .lsn-rubrics-rating-marks-array {
  top: 0;
  bottom: auto;
}
.lsn-question-block-ratings .comment-wrapper .lsn-required-tag,
.lsn-question-block-rubrics .comment-wrapper .lsn-required-tag {
  position: absolute;
  top: -0.4rem;
  left: -0.4rem;
}
.lsn-question-block-ratings .comment-wrapper .fa-comment-alt-lines,
.lsn-question-block-rubrics .comment-wrapper .fa-comment-alt-lines {
  position: relative;
  top: 0;
  color: var(--main-border-color);
}
.lsn-question-block-ratings .comment-wrapper .lsn-form-group,
.lsn-question-block-rubrics .comment-wrapper .lsn-form-group {
  display: grid;
  grid-template-columns: auto 1fr;
  margin: 0;
}
.lsn-question-block-ratings .comment-wrapper .lsn-form-group .lsn-control-label,
.lsn-question-block-rubrics .comment-wrapper .lsn-form-group .lsn-control-label {
  display: flex;
  position: relative;
}
.lsn-question-block-ratings .comment-wrapper .lsn-form-group .lsn-group-control,
.lsn-question-block-rubrics .comment-wrapper .lsn-form-group .lsn-group-control {
  width: 100%;
  padding: 0;
}
.lsn-question-block-ratings .comment-wrapper .lsn-form-group .lsn-form-control-error-message,
.lsn-question-block-rubrics .comment-wrapper .lsn-form-group .lsn-form-control-error-message {
  text-align: left;
  top: var(--main-border-width);
}
.lsn-question-block-ratings .comment-wrapper .lsn-form-group .lsn-control,
.lsn-question-block-rubrics .comment-wrapper .lsn-form-group .lsn-control,
.lsn-question-block-ratings .comment-wrapper .lsn-form-group .lsn-control:hover,
.lsn-question-block-rubrics .comment-wrapper .lsn-form-group .lsn-control:hover,
.lsn-question-block-ratings .comment-wrapper .lsn-form-group .lsn-control:active,
.lsn-question-block-rubrics .comment-wrapper .lsn-form-group .lsn-control:active,
.lsn-question-block-ratings .comment-wrapper .lsn-form-group .lsn-control:focus,
.lsn-question-block-rubrics .comment-wrapper .lsn-form-group .lsn-control:focus {
  border: 0 !important;
  box-shadow: none !important;
}
.lsn-question-block-ratings .comment-wrapper:has(.has-error),
.lsn-question-block-rubrics .comment-wrapper:has(.has-error) {
  border: var(--main-border-width) solid var(--main-red);
}
.lsn-question-block-ratings .comment-wrapper:has(.has-error) .fa-comment-alt-lines,
.lsn-question-block-rubrics .comment-wrapper:has(.has-error) .fa-comment-alt-lines {
  color: var(--main-red);
}
.lsn-question-block-ratings .comment-wrapper:has(.has-error):focus,
.lsn-question-block-rubrics .comment-wrapper:has(.has-error):focus,
.lsn-question-block-ratings .comment-wrapper:has(.has-error):active,
.lsn-question-block-rubrics .comment-wrapper:has(.has-error):active,
.lsn-question-block-ratings .comment-wrapper:has(.has-error):focus-within,
.lsn-question-block-rubrics .comment-wrapper:has(.has-error):focus-within {
  border-color: var(--main-red);
}
.lsn-question-block-ratings .comment-wrapper:has(.has-error):focus::before,
.lsn-question-block-rubrics .comment-wrapper:has(.has-error):focus::before,
.lsn-question-block-ratings .comment-wrapper:has(.has-error):active::before,
.lsn-question-block-rubrics .comment-wrapper:has(.has-error):active::before,
.lsn-question-block-ratings .comment-wrapper:has(.has-error):focus-within::before,
.lsn-question-block-rubrics .comment-wrapper:has(.has-error):focus-within::before {
  border-color: var(--main-red);
}
.lsn-question-block-ratings .comment-wrapper:has(.has-error)::before,
.lsn-question-block-rubrics .comment-wrapper:has(.has-error)::before {
  border-color: var(--main-red);
}
.lsn-question-block-ratings .comment-wrapper textarea:not(:placeholder-shown):disabled,
.lsn-question-block-rubrics .comment-wrapper textarea:not(:placeholder-shown):disabled {
  text-decoration: line-through;
}
.rc-slider-tooltip {
  z-index: 10;
}
.rc-slider-tooltip-inner {
  max-width: 300px;
  height: auto;
  background-color: var(--main-black);
  font-size: 1rem;
}
@container evaluation-form (min-width: 600px) {
  .lsn-question-block-ratings .lsn-rubrics-rating-mark,
  .lsn-question-block-rubrics .lsn-rubrics-rating-mark {
    background-color: var(--main-bg-color-lighter);
  }
  .lsn-question-block-ratings .lsn-rubrics-rating-items,
  .lsn-question-block-rubrics .lsn-rubrics-rating-items {
    position: absolute;
    left: 5%;
    right: 5%;
    align-items: flex-end;
    flex-direction: column;
    row-gap: 0;
    padding: 0;
  }
  .lsn-question-block-ratings .lsn-rubrics-rating-items ~ svg,
  .lsn-question-block-rubrics .lsn-rubrics-rating-items ~ svg {
    display: none;
  }
  .lsn-question-block-ratings .lsn-rubrics-level-item,
  .lsn-question-block-rubrics .lsn-rubrics-level-item {
    position: absolute;
    text-align: end;
    justify-content: flex-end;
    align-items: flex-end;
    width: calc(var(--js-width-perc) * 1);
    max-width: calc(var(--js-width-perc) * 1);
    left: var(--js-left-perc);
    height: 100%;
    transform: translate(-50%, -0.5rem);
    flex-direction: column;
    white-space: normal;
    word-break: break-word;
    align-items: center;
    margin-bottom: 0.4rem;
    text-align: center;
    padding: 0;
  }
  .lsn-question-block-ratings .lsn-rubrics-level-item .shadow-dot,
  .lsn-question-block-rubrics .lsn-rubrics-level-item .shadow-dot {
    display: block;
    position: relative;
    z-index: -1;
    width: 80%;
    height: 0;
    align-self: center;
  }
  .lsn-question-block-ratings .lsn-rubrics-level-item:hover .shadow-dot,
  .lsn-question-block-rubrics .lsn-rubrics-level-item:hover .shadow-dot {
    box-shadow: 0px -22px 25px 16px var(--js-component-color);
  }
  .lsn-question-block-ratings .lsn-rubrics-level-item .lsn-rubrics-levels-tooltip,
  .lsn-question-block-rubrics .lsn-rubrics-level-item .lsn-rubrics-levels-tooltip {
    margin-left: 0;
    margin-top: 0.2rem;
  }
  .lsn-question-block-ratings .floating-panel,
  .lsn-question-block-rubrics .floating-panel {
    min-height: 6rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/recommendationForm/QuestionBlock/components/Rubrics.less"],"names":[],"mappings":"AAAA;;EAIM,kBAAA;EACA,YAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,oBAAA;AADN;AARA;;EAaM,aAAA;EACA,oBAAA;EACA,2BAAA;EACA,kBAAA;AADN;AAfA;;EAqBI,kBAAA;EACA,QAAA;EACA,SAAA;EACA,SAAA;AAFJ;AAtBA;;EA4BI,iBAAA;EACA,cAAA;EACA,cAAA;EACA,0FAAA;EACA,WAAA;EACA,YAAA;EACA,2CAAA;EACA,wDAAA;EACA,kBAAA;EACA,eAAA;EACA,4BAAA;EACA,yBAAA;EACA,UAAA;AAFJ;AAII;;EACE,2DAAA;EACA,YAAA;EACA,MAAA;EACA,UAAA;AADN;AA7CA;;EAmDI,gBAAA;EACA,SAAA;EACA,UAAA;EACA,qBAAA;AAFJ;AApDA;;EA0DI,wCAAA;EACA,kBAAA;EACA,UAAA;EACA,yCAAA;EACA,kDAAA;EACA,WAAA;EACA,6BAAA;EACA,mBAAA;EACA,sBAAA;AAFJ;AAII;;EACE,qDAAA;AADN;AApEA;;EA0EI,MAAA;EACA,SAAA;EACA,aAAA;EACA,sBAAA;EACA,aAAA;EACA,2BAAA;EACA,kBAAA;AAFJ;AA9EA;;EAoFI,gBAAA;EACA,UAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,YAAA;EACA,eAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,2BAAA;EACA,yBAAA;EACA,kBAAA;EACA,iCAAA;AAFJ;AAhGA;;EAqGM,eAAA;EACA,gCAAA;EACA,cAAA;AADN;AAtGA;;EA4GI,UAAA;EACA,UAAA;EACA,yBAAA;EACA,eAAA;AAFJ;AAII;;EAEI,+EAAA;AAFR;AAAI;;EAMI,mFAAA;AAFR;AAJI;;EAUI,iCAAA;AAFR;AAIQ;;EACE,qCAAA;AADV;AAGU;;EACE,iDAAA;AAAZ;AAIQ;;EACE,iCAAA;AADV;AAIQ;;EACE,2HAAA;AADV;AAGU;;EACE,sFAAA;AAAZ;AA5BI;;EAkCI,YAAA;AAFR;AAjJA;;EAyJI,kBAAA;EACA,cAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,2BAAA;EACA,4BAAA;EACA,4BAAA;EACA,6BAAA;EACA,uBAAA;EACA,2CAAA;EACA,4BAAA;EACA,UAAA;EACA,UAAA;AAJJ;AAMI;;EACE,+CAAA;AAHN;AAKM;;EACE,2DAAA;AAFR;AAMI;;EACE,cAAA;EACA,YAAA;EACA,2CAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA;EACA,SAAA;EACA,wBAAA;EACA,UAAA;AAHN;AAMI;;EACE,qIAAA;AAHN;AAKM;;EACE,gGAAA;AAFR;AAhMA;;EAwMI,uBAAA;EACA,8CAAA;EACA,0EAAA;AAJJ;AAtMA;;EA8MI,uBAAA;AAJJ;AA1MA;;EAkNI,uBAAA;AAJJ;AA9MA;;EAqNM,aAAA;AAHN;AAlNA;;EA0NI,sBAAA;EACA,qBAAA;EACA,2BAAA;EACA,sBAAA;EACA,qDAAA;EACA,0EAAA;AAJJ;AAMI;;EACE,8CAAA;EACA,mEAAA;AAHN;AAhOA;;EAwOI,sBAAA;EACA,mBAAA;AAJJ;AArOA;;EA6OI,mBAAA;EACA,aAAA;EACA,sBAAA;AAJJ;AA3OA;;EAmPI,sBAAA;EACA,+DAAA;EACA,gDAAA;EACA,aAAA;EACA,qBAAA;EACA,kBAAA;EACA,6BAAA;EACA,qBAAA;AAJJ;AAMI;;;;;;EAGE,uCAAA;AADN;AAGM;;;;;;EACE,uCAAA;AAIR;AAVI;;;;;;EAWI,gCAAA;AAOR;AA9QA;;EA4QM,MAAA;EACA,YAAA;AAMN;AAnRA;;EAiRM,kBAAA;EACA,YAAA;EACA,aAAA;AAMN;AAzRA;;EAuRM,kBAAA;EACA,MAAA;EACA,+BAAA;AAMN;AA/RA;;EA6RM,aAAA;EACA,+BAAA;EACA,SAAA;AAMN;AArSA;;EAkSQ,aAAA;EACA,kBAAA;AAOR;AA1SA;;EAuSQ,WAAA;EACA,UAAA;AAOR;AA/SA;;EA4SQ,gBAAA;EACA,6BAAA;AAOR;AApTA;;;;;;;;EAoTQ,oBAAA;EACA,2BAAA;AAUR;AANI;;EACE,sDAAA;AASN;AAVI;;EAII,sBAAA;AAUR;AAPM;;;;;;EAGE,6BAAA;AAYR;AAVQ;;;;;;EACE,6BAAA;AAiBV;AAbM;;EACE,6BAAA;AAgBR;AAXM;;EACE,6BAAA;AAcR;AARA;EACE,WAAA;AAUF;AAPA;EACE,gBAAA;EACA,YAAA;EACA,mCAAA;EACA,eAAA;AASF;AAQA;EAEE;;IAII,8CAAA;EATJ;EAKA;;IAQI,kBAAA;IACA,QAAA;IACA,SAAA;IACA,qBAAA;IACA,sBAAA;IACA,UAAA;IACA,UAAA;EATJ;EALA;;IAiBM,aAAA;EARN;EATA;;IAsBI,kBAAA;IACA,eAAA;IACA,yBAAA;IACA,qBAAA;IACA,qCAAA;IACA,yCAAA;IACA,yBAAA;IACA,YAAA;IACA,mCAAA;IACA,sBAAA;IACA,mBAAA;IACA,sBAAA;IACA,mBAAA;IACA,qBAAA;IACA,kBAAA;IACA,UAAA;EATJ;EA5BA;;IAwCM,cAAA;IACA,kBAAA;IACA,WAAA;IACA,UAAA;IACA,SAAA;IACA,kBAAA;EARN;EAWI;;IACE,yDAAA;EARN;EAzCA;;IAqDM,cAAA;IAEA,kBAAA;EATN;EA9CA;;IA4DI,gBAAA;EAVJ;AACF","sourcesContent":[".lsn-question-block-ratings,\n.lsn-question-block-rubrics {\n  .lsn-rubrics-wrapper {\n    .lsn-form-control-error-message {\n      position: absolute;\n      left: 3.5rem;\n      text-align: left;\n      top: -.05rem;\n      line-height: normal;\n      pointer-events: none;\n    }\n\n    input[type='text'] {\n      height: .1px;\n      border: 0 !important;\n      box-shadow: none !important;\n      position: absolute;\n    }\n  }\n\n  .lsn-rubrics-rating-marks-array {\n    position: absolute;\n    left: 5%;\n    right: 5%;\n    bottom: 0;\n  }\n\n  .lsn-rubrics-rating-mark {\n    background: white;\n    display: block;\n    font-size: 0px;\n    box-shadow: color-mix(in srgb, var(--main-primary-color) 40%, transparent) 1px 1px 1px 0px;\n    width: 10px;\n    height: 10px;\n    background-color: var(--js-component-color);\n    transform: translate(-50%, 40%) rotate(45deg) !important;\n    position: absolute;\n    bottom: -.3rem;\n    color: var(--main-dark-gray);\n    left: var(--js-left-perc);\n    z-index: 1;\n\n    &.up {\n      transform: translate(-50%, -50%) rotate(-135deg) !important;\n      bottom: auto;\n      top: 0;\n      z-index: 0;\n    }\n  }\n\n  #likert-header {\n    position: sticky;\n    top: -1px;\n    z-index: 9;\n    margin-bottom: 1.6rem;\n  }\n\n  .floating-panel {\n    background: var(--main-bg-color-lighter);\n    position: relative;\n    z-index: 3;\n    transition: transform 1s, box-shadow .5s;\n    box-shadow: var(--main-dark-gray) 0px 2px 2px -2px;\n    width: 100%;\n    justify-content: space-evenly;\n    margin-bottom: 1rem;\n    padding-bottom: 1.5rem;\n\n    &.sticky {\n      box-shadow: var(--main-dark-gray) 0px 26px 12px -20px;\n    }\n  }\n\n  .lsn-rubrics-rating-items {\n    top: 0;\n    bottom: 0;\n    display: flex;\n    flex-direction: column;\n    row-gap: 1rem;\n    padding: 1rem 0 1rem 2.5rem;\n    position: relative;\n  }\n\n  .lsn-rubrics-level-item {\n    position: static;\n    z-index: 2;\n    display: flex;\n    font-weight: bolder;\n    line-height: normal;\n    flex-grow: 1;\n    cursor: default;\n    width: 100%;\n    max-width: none;\n    min-width: unset;\n    align-items: baseline;\n    flex-direction: row-reverse;\n    justify-content: flex-end;\n    column-gap: .5rem;\n    transform: translate(1%, -.5rem);\n\n    .lsn-rubrics-levels-tooltip {\n      cursor: pointer;\n      color: var(--main-primary-color);\n      display: block;\n    }\n  }\n\n  .rc-slider {\n    width: 90%;\n    padding: 0;\n    margin: 0 auto !important;\n    cursor: pointer;\n\n    &.invalid {\n      .rc-slider-rail {\n        border-color: color-mix(in srgb, var(--main-red), var(--main-white)) !important;\n      }\n\n      .rc-slider-track {\n        background-color: color-mix(in srgb, var(--main-red), var(--main-white)) !important;\n      }\n\n      .rc-slider-handle {\n        background-color: var(--main-red);\n\n        &:focus {\n          box-shadow: 0 0 0 3px var(--main-red);\n\n          &:after {\n            box-shadow: 2.3px 2.3px 0px 1.7px var(--main-red);\n          }\n        }\n\n        &:after {\n          background-color: var(--main-red);\n        }\n\n        &.rc-slider-handle-dragging {\n          box-shadow: 0 0 4px 4px var(--main-red), inset 1px 1px 2px 1px var(--main-black), inset -1px -1px 0px 0px var(--main-white);\n\n          &:after {\n            box-shadow: 4px 4px 4px 1px var(--main-red), inset -1px -1px 0px 0px var(--main-white);\n          }\n        }\n      }\n\n      .rc-slider-dot {\n        opacity: .3;\n      }\n    }\n  }\n\n  .rc-slider-handle {\n    position: absolute;\n    margin-left: 0;\n    margin-top: -2px;\n    width: 14px;\n    height: 16px;\n    cursor: grab;\n    border-top-left-radius: 4px;\n    border-top-right-radius: 4px;\n    border-bottom-left-radius: 0;\n    border-bottom-right-radius: 0;\n    border: none !important;\n    background-color: var(--main-primary-color);\n    background-repeat: no-repeat;\n    opacity: 1;\n    z-index: 2;\n\n    &:focus {\n      box-shadow: 0 0 0 3px var(--main-primary-color);\n\n      &:after {\n        box-shadow: 2.3px 2.3px 0px 1.7px var(--main-primary-color);\n      }\n    }\n\n    &:after {\n      display: block;\n      content: ' ';\n      background-color: var(--main-primary-color);\n      width: 10px;\n      height: 10px;\n      position: absolute;\n      bottom: -5px;\n      left: 2px;\n      transform: rotate(45deg);\n      z-index: 1;\n    }\n\n    &.rc-slider-handle-dragging {\n      box-shadow: 0 0 4px 4px var(--main-primary-color), inset 1px 1px 2px 1px var(--main-black), inset -1px -1px 0px 0px var(--main-white);\n\n      &:after {\n        box-shadow: 4px 4px 4px 1px var(--main-primary-color), inset -1px -1px 0px 0px var(--main-white);\n      }\n    }\n  }\n\n  .rc-slider-rail {\n    height: 15px !important;\n    background-color: var(--main-white) !important;\n    border: var(--main-border-width) solid var(--main-border-color) !important;\n  }\n\n  .rc-slider-track {\n    height: 15px !important;\n  }\n\n  .rc-slider-step {\n    height: 10px !important;\n\n    >span:nth-child(1) {\n      display: none;\n    }\n  }\n\n  .rc-slider-dot {\n    bottom: 0px !important;\n    width: 5px !important;\n    margin-left: 0px !important;\n    height: 5px !important;\n    background-color: var(--main-border-color) !important;\n    border: var(--main-border-width) solid var(--main-border-color) !important;\n\n    &-active {\n      background-color: var(--main-white) !important;\n      border: var(--main-border-width) solid var(--main-white) !important;\n    }\n  }\n\n  .lsn-rubrics-label {\n    padding-bottom: .5rem;\n    padding-right: 2rem;\n  }\n\n  .lsn-rubrics-scales {\n    margin-top: -.5rem;\n    display: flex;\n    flex-direction: column;\n  }\n\n  .comment-wrapper {\n    width: 100% !important;\n    border: var(--main-border-width) solid var(--main-border-color);\n    border-radius: var(--main-control-border-radius);\n    outline: none;\n    padding: 0 0 0 .2rem;\n    position: relative;\n    border-bottom-right-radius: 0;\n    margin: 1.3rem auto 0;\n\n    &:focus,\n    &:active,\n    &:focus-within {\n      border-color: var(--main-primary-color);\n\n      &::before {\n        border-color: var(--main-primary-color);\n      }\n\n      i {\n\n        color: var(--main-primary-color);\n      }\n    }\n\n    .lsn-rubrics-rating-marks-array {\n      top: 0;\n      bottom: auto;\n    }\n\n    .lsn-required-tag {\n      position: absolute;\n      top: -.4rem;\n      left: -.4rem;\n    }\n\n    .fa-comment-alt-lines {\n      position: relative;\n      top: 0;\n      color: var(--main-border-color);\n    }\n\n    .lsn-form-group {\n      display: grid;\n      grid-template-columns: auto 1fr;\n      margin: 0;\n\n      .lsn-control-label {\n        display: flex;\n        position: relative;\n      }\n\n      .lsn-group-control {\n        width: 100%;\n        padding: 0;\n      }\n\n      .lsn-form-control-error-message {\n        text-align: left;\n        top: var(--main-border-width);\n      }\n\n      .lsn-control,\n      .lsn-control:hover,\n      .lsn-control:active,\n      .lsn-control:focus {\n        border: 0 !important;\n        box-shadow: none !important;\n      }\n    }\n\n    &:has(.has-error) {\n      border: var(--main-border-width) solid var(--main-red);\n\n      .fa-comment-alt-lines {\n        color: var(--main-red);\n      }\n\n      &:focus,\n      &:active,\n      &:focus-within {\n        border-color: var(--main-red);\n\n        &::before {\n          border-color: var(--main-red);\n        }\n      }\n\n      &::before {\n        border-color: var(--main-red);\n      }\n    }\n\n    textarea {\n      &:not(:placeholder-shown):disabled {\n        text-decoration: line-through;\n      }\n    }\n  }\n}\n\n.rc-slider-tooltip {\n  z-index: 10;\n}\n\n.rc-slider-tooltip-inner {\n  max-width: 300px;\n  height: auto;\n  background-color: var(--main-black);\n  font-size: 1rem;\n}\n\n// @container evaluation-form (min-width: 400px) {\n\n//   .lsn-question-block-ratings,\n//   .lsn-question-block-rubrics {\n//     .lsn-rubrics-level-item {\n//       // transform: translate(-98%, 0%);\n//       word-break: break-word;\n//       white-space: normal;\n//       width: calc(var(--js-width-perc) * 1);\n//       max-width: calc(var(--js-width-perc) * 1);\n//     }\n//   }\n// }\n\n@container evaluation-form (min-width: 600px) {\n\n  .lsn-question-block-ratings,\n  .lsn-question-block-rubrics {\n\n    .lsn-rubrics-rating-mark {\n      background-color: var(--main-bg-color-lighter);\n    }\n\n    .lsn-rubrics-rating-items {\n      position: absolute;\n      left: 5%;\n      right: 5%;\n      align-items: flex-end;\n      flex-direction: column;\n      row-gap: 0;\n      padding: 0;\n\n      ~svg {\n        display: none;\n      }\n    }\n\n    .lsn-rubrics-level-item {\n      position: absolute;\n      text-align: end;\n      justify-content: flex-end;\n      align-items: flex-end;\n      width: calc(var(--js-width-perc) * 1);\n      max-width: calc(var(--js-width-perc) * 1);\n      left: var(--js-left-perc);\n      height: 100%;\n      transform: translate(-50%, -.5rem);\n      flex-direction: column;\n      white-space: normal;\n      word-break: break-word;\n      align-items: center;\n      margin-bottom: .4rem;\n      text-align: center;\n      padding: 0;\n\n      .shadow-dot {\n        display: block;\n        position: relative;\n        z-index: -1;\n        width: 80%;\n        height: 0;\n        align-self: center;\n      }\n\n      &:hover .shadow-dot {\n        box-shadow: 0px -22px 25px 16px var(--js-component-color);\n      }\n\n      .lsn-rubrics-levels-tooltip {\n        margin-left: 0;\n        // margin-left: .5rem;\n        margin-top: .2rem;\n      }\n    }\n\n    .floating-panel {\n      min-height: 6rem;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
